<div class="row" id="legalTermsComponent">
  <div class="col-lg-10 mx-auto">
    <h1 class="my-4">{{ 'LEGAL.' + clientId + '.LEGALTERMS.ADVICE' | translate }}</h1>
    <div innerHTML="{{ 'LEGAL.' + clientId + '.LEGALTERMS.HTML' | translate}}"></div>
  </div>
</div>
